import React from "react";
import PropTypes from "prop-types";
import { ChevronRight } from "backpack-ui/dist/components/icon";
import styles from "./styles.css";

const CallToAction = ({ url, title }) => (
  <a href={url} className={styles.container}>
    {title}
    <div className={styles.chevron}>
      <ChevronRight />
    </div>
  </a>
);

CallToAction.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default CallToAction;
